// extracted by mini-css-extract-plugin
export default {"AppFooter":"AppFooter_AppFooter__l54bv","AppFooter__Links":"AppFooter_AppFooter__Links__POzWv","AppLayout__Page":"AppFooter_AppLayout__Page__7MO34"};